// DS: i8.5
import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import IconWrap from '../../IconWrap';
export const Error = (props)=>/*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M12 2c5.523 0 10 4.477 10 10a9.998 9.998 0 01-10 10C6.477 22 2 17.523 2 12S6.477 2 12 2zm0 12.75c-.552 0-1 .504-1 1.125S11.448 17 12 17s1-.504 1-1.125-.448-1.125-1-1.125zM12 7a.998.998 0 00-.993.885L11 8.002v4.591c0 .51.386.937.883.995l.117.007.117-.007a.998.998 0 00.876-.878l.007-.117V8.002C13 7.453 12.552 7 12 7z"
    })));
Error.displayName = 'Error';
export default Error;
